import * as React from 'react'
import {InputAddon, TextInput, TextInputProps} from "@vebox/etui-core";

type VeBoxTextInputProps =
    TextInputProps
    & {
    onConfirm?: (event: React.MouseEvent<HTMLSpanElement>, value: string | number | readonly string[]
    ) => void;
    onCancel?: (event: React.MouseEvent<HTMLSpanElement>, defaultValue: string | number | readonly string[]) => void;
    withOperationAddon: boolean;
    canSubmit?: boolean;
    canCancel?: boolean;
}

export const VeBoxTextInput: React.FC<VeBoxTextInputProps> = ({
                                                                  value,
                                                                  onChange,
                                                                  defaultValue,
                                                                  onConfirm,
                                                                  onCancel,
                                                                  className,
                                                                  error,
                                                                  withOperationAddon,
                                                                  canSubmit = true,
                                                                  canCancel = true,
                                                                  readOnly,
                                                                  ...rest
                                                              }) => {

    const [textValue, setTextValue] = React.useState(value);
    const [isTextValueModified, setIsTextValueModified] = React.useState<boolean>(false);
    const [showPencil, setShowPencil] = React.useState<boolean>(true);

    const inputRef = React.useRef(null)

    React.useEffect(() => {
        if (readOnly === false) {
            setIsTextValueModified(value !== defaultValue);
            setTextValue(value);
        }
    }, [value])

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(event)
        } else {
            setTextValue(event.target.value);
        }
    }

    const handleOnSubmit = (event: React.MouseEvent<HTMLSpanElement>): void => {
        if (onConfirm) {
            onConfirm(event, textValue);
        }
    }

    const handleOnCancel = (event: React.MouseEvent<HTMLSpanElement>): void => {
        if (onCancel) {
            onCancel(event, defaultValue);
        } else {
            setTextValue(defaultValue);
        }
    }

    const focusOnInputText = () => {
        inputRef.current.input.focus()
    }

    const showEditInputAddon = (show: boolean) => () => setShowPencil(show)

    const {dangerouslySetInnerHTML, ...other} = rest
    return <TextInput
        value={textValue}
        className={className}
        onChange={handleOnChange}
        onFocus={showEditInputAddon(false)}
        onBlur={showEditInputAddon(true)}
        defaultValue={defaultValue}
        error={error}
        ref={inputRef}
        readOnly={readOnly}
        endInputAddon={
            <>
                {((withOperationAddon && isTextValueModified) || error)
                    ? (
                        <InputAddon position="end">
                            {!error && canSubmit && <span
                                className="material-icons clickable submit-icon"
                                onClick={handleOnSubmit}
                            >done</span>}
                            {canCancel && <span
                                className="material-icons clickable cancel-icon"
                                onClick={handleOnCancel}
                            >clear</span>}
                        </InputAddon>
                    )
                    : null}
                {showPencil && !readOnly && !((withOperationAddon && isTextValueModified) || error)
                    ? (
                        <InputAddon position="end">
                            <span
                                onClick={focusOnInputText}
                                className="material-icons clickable edit-icon"
                            >edit</span>
                        </InputAddon>
                    )
                    : null}
            </>
        }
        {...other}
    />
}